export default __webpack_public_path__ + "static/media/bg.6ae38886.png";